import { Button, type ButtonProps } from '@mui/material'
import { type ReactNode } from 'react'
import GoogleIcon from '@/assets/google-icon.svg'

export function GoogleButton({
  children,
  ...props
}: {
  children: ReactNode
} & ButtonProps) {
  return (
    <Button
      variant="contained"
      startIcon={props.loading ? null : <GoogleIcon />}
      {...props}
      sx={{
        justifyContent: 'flex-start',
        '&.MuiButton-root.MuiButton-containedPrimary': {
          background: 'black',
        },
        '&.Mui-disabled&.MuiButton-root.MuiButton-containedPrimary': {
          background: 'rgba(0, 0, 0, 0.6)',
        },
        ...(props.sx as object),
      }}
    >
      {children}
    </Button>
  )
}
